import { getDataItemByRowId } from './helpers'

export const PackageNameTypesCell = ({
  data,
  rowId,
  packageInfoKey,
  packageNameKey,
}) => {
  const packageTypesItem = getDataItemByRowId(data, rowId)[packageInfoKey] || []
  const firstPackageItem = packageTypesItem[0]
  const remainingPackageItems = packageTypesItem.slice(1)

  return (
    <>
      {firstPackageItem ? firstPackageItem[packageNameKey] : null}
      {!!remainingPackageItems.length &&
        remainingPackageItems.map((item, index) => (
          <div className="mt1" key={index}>
            {item[packageNameKey]}
          </div>
        ))}
    </>
  )
}
